/**
 * Las explicaciones de cabecera, plegadas en el móvil · 13-10-2026
 *
 * Cada pantalla abre con un párrafo que explica qué es y por qué importa. Se lee la
 * primera vez; las demás, en el móvil, son media pantalla de letra antes del primer
 * dato —lo que el primer club llamó «demasiadas letras»—. `tema.css` las pliega a dos
 * líneas con «…», y esto las despliega al tocarlas (y las vuelve a plegar).
 *
 * Un solo oyente en el marco, no un componente en cada pantalla: así vale para las
 * que ya existen y para las que vengan, que es lo que nadie recordaría hacer.
 */
import { useEffect, type RefObject } from 'react';

const PLEGABLES = 'section > h1 + p.tenue, .titulo-fila + p.tenue';

export function useTextosPlegables(caja: RefObject<HTMLElement | null>): void {
  useEffect(() => {
    const el = caja.current;
    if (!el) return;

    const alPulsar = (e: MouseEvent) => {
      const objetivo = e.target as HTMLElement;
      // Un enlace o un botón dentro del párrafo hacen lo suyo, no pliegan.
      if (objetivo.closest('a, button, input, select, textarea, label')) return;
      const parrafo = objetivo.closest<HTMLElement>('p.tenue');
      if (!parrafo || !el.contains(parrafo) || !parrafo.matches(PLEGABLES)) {
        return;
      }
      if (!matchMedia('(max-width: 640px)').matches) return;
      parrafo.classList.toggle('desplegada');
    };

    el.addEventListener('click', alPulsar);
    return () => el.removeEventListener('click', alPulsar);
  }, [caja]);
}
